import React, { useState } from "react";
import "./MarketingAnalyticsCs.scss";
import MegaHeader from "../MegaHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { imageUrl } from "../../utils/imagePath";
import { Modal } from "react-bootstrap";

const MarketingAnalyticsCs = () => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  return (
    <>
      <MegaHeader />
      <div className="strategy-container-mktg" style={{ backgroundImage: `url(${imageUrl("common", "mktnbg.png")})` }}>
        <div className="strategy-text-mktg">
          <h1 className="mktg-main-heading">
            From Data Overload to Digital Mastery: Our Analytics Success Story
          </h1>
          <p className="mktg-subheading mt-5">
            Witnessing an advanced analytics approach boost website performance,
            increasing user engagement, and ignite conversions across the globe
          </p>
        </div>
      </div>

      <div className="row" style={{ marginTop: "10vw" }}>
        <div className="col-4 d-flex align-items-center">
          <img
            onClick={handleShow}
            src={imageUrl("marketing-analytics-cs", "dpxGA.png")}
            // height={350}
            // width={350}
            alt="lp"
            style={{ cursor: "pointer" }}
          ></img>
        </div>
        <div className="col-lg-8 col-md-8 px-5">
          <div>
            <p className="problem">Problem</p>
            <p className="pb-subheading">
              Data Pilot was drowning in unused data, missing out on prime
              opportunities to dominate search results, engage visitors, and
              turn clicks into customers. Our digital presence needed awakening.
            </p>
          </div>

          <div>
            <p className="problem">Solution</p>
            <p className="pb-subheading">
              We built a game-changing analytics dashboard, fusing the might of
              Google Analytics and Search Console featuring:
            </p>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s1.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>
                  Laser-focused performance metrics 
                </p>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s2.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>Hidden keyword gems </p>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s3.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>Landing page superstars </p>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s4.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>
                  The secret sauce of user engagement 
                </p>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s5.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>
                  A world map of untapped markets 
                </p>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex">
                <img src={imageUrl("marketing-analytics-cs", "s6.png")} alt="80"></img>

                <p style={{ marginLeft: "1vw" }}>
                  The alchemy of turning campaigns into conversions 
                </p>
              </div>
            </div>
            <div className="col-6" style={{paddingLeft:"6vw"}}>
            <img src={imageUrl("common", "gcp.png")} alt="gcp" height={76} width={108}></img>
            <img src={imageUrl("common", "looker.png")} alt="gcp" height={70} width={160}></img>
            </div>

          </div>
        </div>
      </div>

      <div className="row" style={{ marginTop: "10vw" }}>
        <div className="col-lg-6 col-md-6 px-5">
          <p className="problem">Impact</p>
          <div className="d-flex">
            <img src={imageUrl("marketing-analytics-cs", "s7.png")} alt="80"></img>

            <p style={{ marginLeft: "1vw" }}>
              CTR skyrocketed to <strong>1.57%</strong>, with a jaw-dropping{" "}
              <strong>45,242</strong> impressions and <strong>8,471</strong> active users
              swarming the site 
            </p>
          </div>

          <div className="d-flex">
            <img src={imageUrl("marketing-analytics-cs", "s8.png")} alt="81"></img>

            <p style={{ marginLeft: "1vw" }}>
              Captivated audiences like never before, with <strong>43%</strong> of visitors
              devouring <strong>75%</strong> of content 
            </p>
          </div>

          <div className="d-flex">
            <img src={imageUrl("marketing-analytics-cs", "s9.png")} alt="80"></img>

            <p style={{ marginLeft: "1vw" }}>
              Planted digital flags across the globe, with the US leading the
              charge and new markets emerging at lightning speed 
            </p>
          </div>

          <div className="d-flex mt-2">
            <img src={imageUrl("marketing-analytics-cs", "s10.png")} alt="80"></img>

            <p style={{ marginLeft: "1vw" }}>
              Turbo-charged conversions: <strong>48</strong> potential clients reached out, with
              <strong>6</strong>ready to take the plunge 
            </p>
          </div>

          <div className="d-flex mt-2">
            <img src={imageUrl("marketing-analytics-cs", "s3.png")} alt="80"></img>

            <p style={{ marginLeft: "1vw" }}>
              Unmasked the superstar campaigns, paving the way for laser-focused
              marketing domination 
            </p>
          </div>
        </div>

        <div className="col-6 ">
          <img
            className="w-100"
            onClick={handleShow}
            src={imageUrl("marketing-analytics-cs", "Mac Studio.png")}
            height={700}
            // width={350}
            alt="lp"
            style={{ cursor: "pointer" }}
          ></img>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleClose}
        className="custom-modal"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>GA 4</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            title="d"
            style={{ width: "100%", height: "700px" }}
            frameBorder="0"
            allowFullScreen="true"
            src="https://lookerstudio.google.com/embed/reporting/7ff6140c-23ef-4463-a1a1-dafcf3e818ec/page/p_pjz486avjd"
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MarketingAnalyticsCs;
